import { useThemeColorStore } from '@/stores/useBackgroundStore';
import { ColorScheme } from '@/types/features';

const fallbackScheme: ColorScheme = {
    bg: 'bg-color-theme-default',
    bgText: 'text-color-theme-default-bg',
    text: 'text-color-theme-default',
    bgBorder: 'border-color-theme-default-bg',
    border: 'border-color-theme-default',
};

export const useThemeColor = () => {
    const scheme = useThemeColorStore((s) => s.scheme) ?? fallbackScheme;
    const setScheme = useThemeColorStore((s) => s.setScheme);
    return { scheme, setScheme };
};
